import type { ActionFunctionArgs } from '~/types/route-args';
import { data as routerData } from 'react-router';
import { z } from 'zod';
import { archiveConversation } from '~/modules/chat/api/archive-conversation.server';

export const ARCHIVE_CONVERSATION_API = '/remix-api/chat/archive';

const FORM_DATA_SCHEMA = z.object({
    conversationID: z.coerce.number().int().positive(),
    professionalID: z.coerce.number().int().positive().nullish(),
    isArchived: z.coerce.boolean(),
});

/**
 * API endpoint to archive/unarchive a conversation. Use with the `useUpdateConversation` hook.
 * @see {@link packages/web/app/modules/chat/hooks/use-update-conversation.ts}
 */
export const action = async ({ context, request }: ActionFunctionArgs) => {
    const { logger } = context;
    const payload = await request.json();
    const result = FORM_DATA_SCHEMA.safeParse(payload);

    if (!result.success) {
        return routerData(null, { status: 400 });
    }

    try {
        const response = await archiveConversation({
            context,
            conversationID: result.data.conversationID,
            professionalID: result.data.professionalID,
            isArchived: result.data.isArchived,
        });

        if (!response) {
            return routerData(null, { status: 500 });
        }

        return { conversation: response.conversation };
    } catch (error) {
        logger.error(`Error in ${ARCHIVE_CONVERSATION_API}`, {
            error,
            data: result.data,
        });
        return routerData(null, { status: 500 });
    }
};
